import React, { useEffect, useState } from "react";
import { Formik } from "formik";
import { Button, FormGroup, Form } from "reactstrap";
import PayIncenticeModal from "../../../TripsDetailsV2/Components/PayIncenticeModal";
import ManageDriverAddBalance from "../../../Modals/ManageDriverAddBalance";
import ManageDriverAddNewExpense from "../../../Modals/ManageDriverAddNewExpense";
import SelectVendorModal from "../../../Vendor/Components/Modal/SelectVendorModal.js";
import { useDispatch, useSelector } from "react-redux";
import {
  getVendorAction,
  transferTorVendorAction,
} from "../../../../services/Store/Actions/beneficiaryAction";
import PaymentModal from "../../../Vendor/Components/Modal/PaymentModal";
import PinModal from "../../../Vendor/Components/Modal/PinModal";
import SuccessModal from "../../../Vendor/Components/Modal/SuccessModal";
import Toast from "../../../subComponents/toast";
import { wait } from "@testing-library/user-event/dist/utils";
function ViewExpanseCard(props) {
  const { tripData, tripExpense } = props;
  const [openChooseMethod, setOpenChooseModal] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open, setOpen] = useState(false);
  const [amount, setAmount] = useState("");
  const [vendorModal, setVendorModal] = useState(false);
  const [vendorData, setVendorData] = useState(false);
  const [selectVendorModal, setSelectVendorModal] = useState(false);
  const [search, setSearch] = useState("");
  const [paymetModal, setPaymentModal] = useState(false);
  const [enterPin, setEnterPin] = useState(false);
  const [paymentData, setPaymentData] = useState("");
  const [pinLoader, setPinLoader] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [failedModal, setFailedModal] = useState(false);
  const [successText, setSuccessText] = useState("");
  const [failedMsg, setFailedMsg] = useState();
  const vehicleDetails = useSelector((state) => state?.fastag?.vehicleDetails);
  const omc_balace = useSelector((state) => state?.omc?.omc_balace);
  const balanceRecord = useSelector(
    (state) => state?.LogipeCard?.balanceRecord
  );
  const bal =
    !balanceRecord?.balance && balanceRecord?.balance === null
      ? "N/A"
      : balanceRecord?.balance;
  const chooseModal = () => {
    setOpenChooseModal(true);
  };
  const handleChooseModal = () => {
    setOpenChooseModal(false);
  };
  const toggleChooseModal = () => {
    setOpenChooseModal(!openChooseMethod);
  };
  const toggleModal3 = () => {
    setOpen3(!open3);
  };
  const handleClose3 = () => {
    setOpen3(false);
  };
  const rechargeCard = () => {
    setOpen3(true);
  };
  const addExpense = () => {
    setOpen(true);
  };
  const handleClose2 = () => {
    setOpen(false);
  };
  const toggleModal2 = () => {
    setOpen(!open);
  };
  const dispatch = useDispatch();
  console.log("tripDataViewExpanseCardtripData",tripData, tripExpense,vehicleDetails,balanceRecord);
  useEffect(() => {
    dispatch(
      getVendorAction({
        isLogipeVendor: "0",
        limit: 4,
        offset: 0,
        search: search,
      })
    );
  }, []);
  return (
    <div className={"endTripCard"} style={{ padding: "12px", flex: 1 }}>
      <div
        style={{
          alignSelf: "center",
          fontWeight: 600,
        }}
      >
        <text>Trip Expanses</text>
      </div>
      <div
        style={{
          margin: "10px",
          flex: 1,
          display: "inline-grid",
        }}
        // className="justify-content-between"
      >
        <div style={{}} className="d-flex justify-content-between ">
          <div>
            <div style={{ opacity: 0 }}>{" . "} </div>
            <div>Balance - </div>
          </div>
          <div>
            <div style={{ fontWeight: 600 }}> Fastag Balance: </div>
            <div>₹{vehicleDetails?.Response?.availableBal?.toLocaleString('en-IN') || "0"} </div>
          </div>
          <div>
            <div style={{ fontWeight: 600 }}> Card Balance: </div>
            <div>₹{bal?.toLocaleString('en-IN') || "0"}</div>
          </div>
          <div>
            <div style={{ fontWeight: 600 }}> Fuel Wallet Balance: </div>
            <div>₹{omc_balace?.balance?.toLocaleString('en-IN') || "0"}</div>
          </div>
        </div>
        <div style={{}} className="d-flex justify-content-between mt-3">
          <div>
            <div style={{ fontWeight: 600 }}> Shortage: </div>
            <div>{tripExpense?.Shortage?.toLocaleString('en-IN') || 0} </div>
          </div>
          <div>
            <div style={{ fontWeight: 600 }}> Penalties: </div>
            <div>₹ {tripExpense?.Penalties?.toLocaleString('en-IN') || 0}</div>
          </div>
          <div>
            <div style={{ fontWeight: 600 }}> Total Earnings: </div>
            <div>₹ {tripExpense?.Earnings?.toLocaleString('en-IN') || 0}</div>
          </div>
        </div>
        <Formik
          // enableReinitialize
          initialValues={{
            amount: "",
          }}
          onSubmit={(values, actions) => {
            setAmount(values?.amount);
            chooseModal();
          }}
        >
          {({ handleSubmit, values, touched, errors, setFieldValue }) => (
            <Form
              onSubmit={handleSubmit}
              className="mt-3"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <FormGroup className="adjustingMargin">
                <div className="heading3 semiBold">Total Incentive Paid:</div>
                <div className="mt-2">₹{tripExpense?.totalIncentive}</div>
              </FormGroup>
              <FormGroup className="adjustingMargin">
                <div className="heading3 semiBold">Pay More Incentive:</div>
                <div className="custNamepadd3">
                  <input
                    type="number"
                    id="amount"
                    className={`inputBoxCust1 ${
                      touched.amount && errors.amount ? "is-invalid" : ""
                    }`}
                    name="amount"
                    onChange={(event) => {
                      // setSearch(event.target.value);
                      setFieldValue("amount", event.target.value, true);
                    }}
                    value={values.amount}
                    touched={touched.amount}
                    errors={errors.amount}
                    placeholder="Amount( Rs. )"
                    autoComplete={"off"}
                  />
                </div>
              </FormGroup>

              <FormGroup className="adjustingMargin" style={{ width: "30%" }}>
                <Button
                  type="submit"
                  className="generateOtp text3 Medium btn btn-secondary"
                >
                  Pay
                </Button>
              </FormGroup>
            </Form>
          )}
        </Formik>
      </div>
      <PayIncenticeModal
        tripData={tripData}
        open={openChooseMethod}
        toggleModal={toggleChooseModal}
        handleClose={handleChooseModal}
        handleVendorPayment={() => {
          setSelectVendorModal(true);
        }}
        handleCashPayment={addExpense}
        handleCardPayment={rechargeCard}
      />
      <ManageDriverAddBalance
        open={open3}
        toggleModal={toggleModal3}
        amount={amount}
        remarks={`Incentive Paid for Trip ${tripData?.tripNo}`}
        title="Logipe Account"
        handleClose={handleClose3}
        color={"title-color2"}
        name="Add Balance"
        userId={tripData?.userId}
        cardType={tripData?.cardType}
        trip={true}
        driverName={tripData?.User?.fullName}
        itemTemp={tripData}
        tripKey={"incentive"}
      />
      <ManageDriverAddNewExpense
        userId={tripData?.userId}
        amount={amount}
        expenseType={"Incentive"}
        remarks={`Incentive Paid for Trip ${tripData?.tripNo}`}
        setDisplayName={"Add Expense"}
        displayName={"Add Expense"}
        open={open}
        toggleModal={toggleModal2}
        title="Logipe Account"
        handleClose={handleClose2}
        trip={true}
        itemTemp={tripData}
        tripKey={"incentive"}
        color={
          "LogipeAccount" === "Card Wallet" ? "title-color1" : "title-color2"
        }
      />
      {paymetModal && (
        <PaymentModal
          open={paymetModal}
          onHide={() => {
            setPaymentModal(false);
            setVendorData({});
          }}
          remarks={`Incentive Paid for Trip ${tripData?.tripNo}`}
          toggleModal={() => {
            setVendorData({});
            setPaymentModal(!paymetModal);
          }}
          handleClose={() => {
            setVendorData({});
            setPaymentModal(false);
          }}
          onSubmit={(data) => {
            setPaymentModal(false);
            setEnterPin(true);
            setPaymentData(data);
          }}
          vendorData={vendorData}
        />
      )}
      {enterPin && (
        <PinModal
          open={enterPin}
          onHide={() => {
            setVendorData({});
            setEnterPin(false);
          }}
          toggleModal={() => {
            setVendorData({});
            setEnterPin(!enterPin);
          }}
          handleClose={() => {
            setVendorData({});
            setEnterPin(false);
          }}
          pinLoader={pinLoader}
          onSubmit={(data) => {
            setPinLoader(true);
            dispatch(
              transferTorVendorAction(
                {
                  mode: vendorData?.vpaId == "" ? "BANK_TRANSFER" : "UPI",
                  pin: data?.pin?.toString(),
                  amount: paymentData?.amount?.toString(),
                  remark: paymentData?.remarks,
                  vendorId: vendorData?.id?.toString(),
                  tripId: tripData?.tripId,
                  tripKey: "incentive",
                },
                (res) => {
                  setPinLoader(false);
                  console.log(res?.data);
                  setVendorData({});
                  if (res?.status == 200) {
                    setSuccessModal(true);
                    setSuccessText(
                      `₹${paymentData?.amount} has been payed to your vendor from Master Account.`
                    );
                    setEnterPin(false);
                  } else {
                    setFailedMsg(res?.data?.message);
                    setSuccessModal(false);
                    setEnterPin(false);
                    setFailedModal(true);
                  }
                }
              )
            );
          }}
          data={paymentData}
          isLogipeVendor={0}
        />
      )}
      {successModal && (
        <SuccessModal
          open={successModal}
          onHide={() => {
            setSuccessModal(false);
            setPaymentData({});
            setSuccessText("");
          }}
          toggleModal={() => {
            setSuccessModal(!successModal);
            setPaymentData({});
            setSuccessText("");
          }}
          handleClose={() => {
            setSuccessModal(false);
            setPaymentData({});
            setSuccessText("");
          }}
          text={successText}
        />
      )}
      {failedModal && (
        <Toast
          success={0}
          message={failedMsg || "Failed to Transfer Amount"}
          toggleModal={() => {
            setFailedModal(false);
            setFailedMsg();
          }}
          isOpen={failedModal}
          name="vendor"
          handleClose={() => {
            setFailedModal(false);
            setFailedMsg();
          }}
        />
      )}
      {selectVendorModal && (
        <SelectVendorModal
          open={selectVendorModal}
          onHide={() => {
            setSelectVendorModal(false);
          }}
          toggleModal={() => {
            setSelectVendorModal(!selectVendorModal);
          }}
          handleClose={() => {
            setSelectVendorModal(false);
          }}
          onClickItem={(data) => {
            setVendorData({});
            setVendorData(data);
            setPaymentModal(true);
            setSelectVendorModal(false);
          }}
          search={search}
          setSearch={setSearch}
        />
      )}
    </div>
  );
}
export default ViewExpanseCard;
